module.exports = __webpack_public_path__ + "img/serbia.6e843b9e.svg";